import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { DespesaService } from '../services/despesa.service';
import { TipoDespesaService } from '../services/tipo-despesa.service';

@Component({
	selector: 'app-despesas',
	templateUrl: './despesas.component.html',
	styleUrls: ['./despesas.component.css'],
	animations: [loadingFade, modal, alert]
})
export class DespesasComponent implements OnInit {
	public loading = false;
	public despesas = [];
	public formFiltro: FormGroup;

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idDespesaApagar = null;

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	// filtro
	public filtro = {};
	public tipo_despesa_array = [];

	constructor(private fb: FormBuilder,
				private despesaSvc: DespesaService,
				private tipoDespesaSvc: TipoDespesaService) { }

	ngOnInit() {
		this.pegaDespesas();
	}

	pegaTipoDespesas() {
		this.tipoDespesaSvc.getTiposDespesa('tipo_despesa_nome').then((data: any[]) => {
			this.tipo_despesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaDespesas() {
		this.despesas = [];
		this.loading = true;
		this.despesaSvc.getDespesas().then((data: any[]) => {
			this.despesas = data;
			this.count = this.despesas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;
	}

	perguntaApagar(id) {
		this.modalApagar = 'shown';
		this.idDespesaApagar = id;
	}

	cancelaApagar() {
		this.modalApagar = 'hidden';
	}

	apagaDespesa() {
		this.modalApagar = 'hidden';
		this.loading = true;
		this.despesaSvc.apagaDespesa(this.idDespesaApagar).then((data) => {
			this.mostraMsg('Despesa apagada com sucesso.', 'alert-success');
			this.pegaDespesas();
		}).catch((err) => {
			console.log(err);
			this.mostraMsg('Problema ao apagar despesa.', 'alert-danger');
			this.loading = false;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}
}
